import { render, staticRenderFns } from "./basicuser.vue?vue&type=template&id=0195de6a&"
import script from "./basicuser.vue?vue&type=script&lang=js&"
export * from "./basicuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports